import { useRouter } from 'next/compat/router'
import Link from 'next/link'
import { useSelector } from 'react-redux'

import { Box } from '@chakra-ui/react'

import { ColorScheme, SideNavItem } from '@hivewatch/dark'

import { selectSideNavOpen } from '@/redux/ui/uiSlice'

interface IProps {
  label: string
  icon: React.ElementType
  iconSize?: string
  onClick?: () => void
  path?: string
  activePaths?: string[]
  dataTestId?: string
  badge?: React.ReactNode
  colorScheme?: ColorScheme
}

export const SideBarNavItem = ({
  label,
  icon,
  iconSize,
  onClick,
  path,
  activePaths,
  dataTestId,
  badge,
  colorScheme,
}: IProps) => {
  const { pathname } = useRouter()
  const isSideNavOpen = useSelector(selectSideNavOpen)
  const isActive =
    pathname === path || (activePaths?.includes(pathname) ?? false)

  const item = (
    <SideNavItem
      badge={badge}
      colorScheme={colorScheme}
      data-testid={dataTestId}
      icon={icon}
      iconSize={iconSize}
      isActive={isActive}
      isExpanded={isSideNavOpen}
      label={label}
      onClick={onClick}
    />
  )

  if (!path) return item

  return (
    <Link href={path} legacyBehavior passHref>
      <Box as='a' color='inherit' textDecoration='none'>
        {item}
      </Box>
    </Link>
  )
}
